<div class="wrapper">

  <section id="area-breadcrumb" class="area-top">
    <div class="container">
      <div class="area-breadcrumb">
        <nav class="breadcrumb">
          <ul>
            <li><a href="/"><strong>Home</strong></a></li>
            <span><i class="fas fa-chevron-right"></i></span>
            <li>Como Funciona</li>
          </ul>
        </nav>
      </div>
    </div>
  </section>

  <section id="como-funciona">
    <div class="container">
      <div class="columns">
        <div class="area-texto column is-offset-1 is-10">
          <img class="icon-montreal" src="assets/img/logo-duvidas.png" alt="montreal-viagens-logo-duvida"/>
          <div *ngIf="!isMobile" class="menu-right">
            <ul class="nav-page">
              <li><a (click)="scroll('target_guia_rapido')">Guia Rápido</a></li>
              <li><a (click)="scroll('target_canais_contato')">Canais de Contato</a></li>
              <li><a (click)="scroll('target_regulamento_clube_montreal')">Regulamentos da Montreal Viagens</a></li>
            </ul>
          </div>
          <h1 class="title">Clube de hospedagem, Clube de turismo, Clube de Assinatura de Hotéis ou clube de viagem vale a pena?</h1>
<!--          <p class="clube-hospedagem-title"><strong>Tudo o que você precisa saber sobre essas modalidades</strong></p>-->
          <p class="clube-hospedagem">
            Tudo o que você precisa saber sobre Clube de Hospedagem, Clube de Turismo ou Clube de Viagem.
            Entenda o que é um Clube de Hospedagem e descubra mais.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="accordions" id="perguntas">
    <div class="container">
      <div class="columns">
        <div class="area-texto column is-offset-1 is-10">
          <h5 id="target_guia_rapido">Guia rápido</h5>

          <div id="ac-1" class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-1" class="btn-control" />
            <label class="btn" for="btnControl-1">
              <div class="perguntas">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  <strong>1) O que é?</strong><br>
                  <small>
                    <span style="font-weight: 700">Entenda o que é um Clube de Hospedagem e os serviços que oferecemos para nossos clientes.</span>
                  </small>
                </p>
                <label class="area-check">
                  <p>
                    Clube de Hospedagem, Clube de Turismo, Clube de Assinatura de Hotéis ou Clube de Viagem é
                    um serviço indicado para quem viaja com frequência, seja a negócios ou a lazer. São como uma
                    ponte de negociação direta com o estabelecimento hoteleiro, garantindo economia e
                    flexibilidade na hora da aquisição de diárias para hospedagem.
                  </p>

                  <p>
                    No Clube de Assinatura de Hotéis da Montreal Viagens, o cliente paga mensalmente uma
                    assinatura anual e adquire diárias para se hospedar nos melhores hotéis, pousadas e resorts
                    parceiros.
                  </p>

                  <p>
                    Os planos de assinatura de hospedagem são personalizáveis, bastando
                    <span style="font-weight: 700">escolher o que mais combina com seu estilo de viagem</span>,
                    o <span style="font-weight: 700">número de diárias que irá utilizar</span> e
                    o <span style="font-weight: 700">número de pessoas que irão viajar</span>.
                  </p>

                  <p>
                    Na Montreal Viagens, oferecemos 6 tipos de planos de hospedagem, divididos em categorias referentes
                    aos hotéis disponíveis para utilização. O grande diferencial do nosso Clube de Viagem é que você não
                    precisa se preocupar com pagamentos extras como taxa de adesão, complemento de diárias ou alimentação
                    do hotel: está tudo incluso em sua assinatura, nos hotéis disponíveis em cada categoria.
                  </p>

                  <p>
                    Todos os planos <span style="font-weight: 700">incluem café da manhã</span>,
                    até <span style="font-weight: 700">24 meses para utilizar</span> (mediante renovação) e o
                    melhor: o
                    <span style="font-weight: 700">
                      pagamento é feito em 12x sem juros e sem comprometer o limite do seu cartão de
                      crédito
                    </span>!
                  </p>
                  <p>
                    Quer saber mais sobre o que é um Clube de Hospedagem? Converse com a Mel, nossa
                    atendente virtual, pelo WhatsApp clicando
                    <a href="https://api.whatsapp.com/send?1=pt_BR&phone=5561996863311"
                       style="text-decoration: underline!important; color: #0f81cc;">
                      aqui!
                    </a>
                  </p>
                </label>
              </div>
            </label>
          </div>

          <div id="ac-2" class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-2" class="btn-control" />
            <label class="btn" for="btnControl-2">
              <div class="perguntas">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  <strong>2) Como funciona?</strong><br>
                  <small>
                    <span style="font-weight: 700">
                      Saiba como funciona um Clube de Hospedagem e conheça os lugares mais incríveis do Brasil e no
                      exterior.
                    </span>
                  </small>
                </p>
                <label class="area-check">
                  <p>
                    O Clube de Assinatura de Viagem da Montreal oferta serviços de aquisição de pacotes de
                    diárias para hospedagem em hotéis, pousadas e resorts no Brasil e no exterior. Aqui você
                    garante economia se comparado ao cobrado diretamente no balcão do hotel e em até outras
                    plataformas de hospedagem, sendo a melhor alternativa para se hospedar de forma barata,
                    sem perder a qualidade em seu descanso.
                  </p>
                  <p>
                    Após adquirir o plano de hospedagem, você tem a possibilidade de utilizar suas diárias por até 2 anos
                    (mediante renovação) respeitando o prazo de agendamento. Suas reservas podem ser feitas de imediato,
                    mediante disponibilidade nos estabelecimentos hoteleiros e com o prazo máximo de 90 dias
                    de antecedência ao check-in no hotel.
                  </p>

                  <p>
                    Os planos da Montreal incluem hotéis no Brasil e alguns no exterior. A lista completa de
                    acomodações está disponível no nosso
                    <a class="link-default" href="/hoteis">site</a>
                    ,onde você pode pesquisar pelo nome da
                    acomodação ou pelo destino desejado. Os hotéis parceiros são selecionados por consultores
                    altamente qualificados e passam por uma rígida classificação para poderem estar em nosso
                    portfólio.
                  </p>
                  <p>
                    Importante informar que nossos planos de hospedagem não incluem passagens aéreas ou
                    traslado. Esses serviços podem ser adquiridos no
                    <a class="link-default" href="https://guruviagem.com.br/" target="_blank">.Guru</a>,
                    nosso site de venda de passagens
                    aéreas, aluguel de carros, pacotes turísticos e muito mais.
                  </p>
                  <p>
                    Ainda possui alguma dúvida?
                  </p>
                  <p>
                    <span style="font-weight: 700">Assista ao nosso vídeo abaixo!</span>
                  </p>

                  <style>
                    .embed-container {
                      position: relative;
                      padding-bottom: 56.25%;
                      height: 0;
                      overflow: hidden;
                      max-width: 100%;
                    }

                    .embed-container iframe,
                    .embed-container object,
                    .embed-container embed {
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                    }

                  </style>
                  <div class="embed-container">
                    <iframe [src]="srcYoutube | urlPipe" frameborder="0" allowfullscreen=""></iframe>
                  </div>

                </label>
              </div>
            </label>
          </div>

          <div id="ac-3" class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-3" class="btn-control" />
            <label class="btn" for="btnControl-3">
              <div class="perguntas">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  <strong>3) Como assinar um plano da Montreal Viagens?</strong><br>
                  <small>
                    <span style="font-weight: 700">
                      Conheça nossos planos de hospedagem, quanto custa para assinar e como entrar para a Montreal!
                    </span>
                  </small>
                </p>
                <label class="area-check">
                  <div id="passo-1">
                    <p  style="font-weight: 700">
                      <span class="numero-passos">1 -</span> ESCOLHA O PLANO QUE MAIS COMBINA COM VOCÊ
                    </p>
                    <p>
                      São 6 modalidades para escolher e com certeza aqui você irá encontrar o plano de
                      hospedagem que é a cara da sua viagem. Conheça:
                    </p>
<!--                    <div id="plano-basico">-->
<!--                      <p style="font-weight: 700">Plano Básico</p>-->
<!--                      <p>-->
<!--                        O plano Básico tem hotéis confortáveis para sua viagem com café da manhã grátis.-->
<!--                      </p>-->
<!--                    </div>-->

                    <div id="plano-completo">
                      <p style="font-weight: 700">Plano Completo</p>
                      <p>
                        O plano Completo tem hotéis confortáveis para sua viagem com café da manhã grátis.
                      </p>
                    </div>

                    <div id="plano-ideal">
                      <p style="font-weight: 700">Plano Ideal</p>
                      <p>
                        Esse plano possui hotéis dos planos Completo e Ideal. As hospedagens podem ter café da manhã,
                        meia pensão e até pensão completa!
                      </p>
                    </div>

                    <div id="plano-exclusivo">
                      <p style="font-weight: 700">Plano Exclusivo</p>
                      <p>
                        Com o plano Exclusivo você conta com hotéis das categorias Completo, Ideal e Exclusivo.
                        Nesta seleção, você encontra mais hospedagens com café, meia pensão e pensão completa.
                      </p>

                    </div>

                    <div id="plano-requinte">
                      <p style="font-weight: 700">Plano Requinte</p>
                      <p>
                        Aqui você pode reservar em qualquer hotel das categorias Completo, Ideal, Exclusivo e Requinte.
                        Hotéis que vão desde café da manhã até all inclusive para escolher.
                      </p>
                    </div>

                    <div id="plano-plus">
                      <p style="font-weight: 700">Plano Plus</p>
                      <p>
                        Hospedagens inesquecíveis esperam por você! Hotéis das categorias Completo, Ideal, Exclusivo,
                        Requinte e Plus para escolher, sendo vários com all inclusive.
                      </p>
                    </div>

                    <div id="plano-black">
                      <p style="font-weight: 700">Plano Black</p>
                      <p>
                        Os melhores hotéis do país com muito luxo te aguardam. Hotéis dos planos Completo, Ideal,
                        Exclusivo, Requinte, Plus e Black estão aqui.
                        All Inclusive e hospedagens espetaculares para você.
                      </p>
                    </div>
                    <p>
                      Quer saber em qual plano está o hotel dos seus sonhos? Consulte aqui em nosso
                      <a class="link-default" href="/hoteis">buscador de hotéis.</a>
                    </p>
                  </div>

                  <div id="passo-2">
                    <p style="font-weight: 700">
                      <span class="numero-passos">2 -</span> ESCOLHA A QUANTIDADE DE DIÁRIAS
                    </p>
                    <p>
                      Hora de definir a quantidade de diárias que irá utilizar em sua hospedagem.
                      Na Montreal você pode configurar sua assinatura a partir de 4 diárias,
                      limitando-se ao total de 28 diárias.
                    </p>
                  </div>

                  <div id="passo-3">
                    <p style="font-weight: 700">
                      <span class="numero-passos">3 -</span> ESCOLHA A QUANTIDADE DE QUARTO/ PESSOAS QUE IRÃO VIAJAR
                    </p>
                    <p>
                      Temos em nossos planos de hospedagem a opção de quartos duplos ou triplos, sendo esses os
                      números máximos de pessoas que podem ocupar a acomodação (duas e três pessoas, respectivamente).
                    </p>
                    <p>
                      Assim, caso queira viajar sozinho ou acompanhado de mais uma pessoa, basta escolher um
                      quarto duplo. Se a viagem for com três pessoas o quarto triplo é ideal, mas se você for viajar
                      em família ou em um grupo maior de hóspedes, você pode fazer combinações diversas entre o
                      número de pessoas e de quartos!
                    </p>
                  </div>

                  <div id="passo-4">
                    <p style="font-weight: 700">
                      <span class="numero-passos">4 - </span>COMPRE SEU PLANO DE HOSPEDAGEM
                    </p>
                    <p style="font-weight: 700">Compre Online</p>
                    <p>
                      Adquira online aqui mesmo com a gente.
                      O <a class="link-default" (click) = "goToCart()">site de compra da Montreal</a>
                      é seguro e sua aquisição é simples e intuitiva.
                    </p>
                    <p style="font-weight: 700">Televendas</p>
                    <p>
                      A compra dos planos de hospedagem pode ser realizada através do televendas com um de
                      nossos consultores especializados, que atendem de segunda a sexta-feira, das 9h às 18h.
                    </p>
                    <p>
                      Ligue já <a class="link-default" href="tel:08006102200">0800 610 2200</a> e fale com a gente.
                    </p>
                    <p>
                      Conheça mais sobre
                      <a class="link-default" (click) = "goToCart()"> os planos de hospedagem </a>
                      da Montreal!
                    </p>
                  </div>
                </label>
              </div>
            </label>
          </div>

          <div id="ac-4" class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-4" class="btn-control" />
            <label class="btn" for="btnControl-4">
              <div class="perguntas">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  <strong>4) Por que entrar?</strong><br>
                  <small>
                    <span style="font-weight: 700">
                      Ideal para quem procura comodidade e economia em hotéis, pousadas e resorts com qualidade.
                    </span>
                  </small>
                </p>
                <label class="area-check">
                  <p>
                    Somos como uma poupança de viagem onde todo mês você deposita um pequeno valor e não
                    precisa se preocupar com sua hospedagem na hora de marcar o seu tão sonhado descanso.
                  </p>
                  <p>
                    Um clube de hospedagem, clube de turismo, clube de viagem e até também conhecido como
                    clube de assinatura de hotéis, garante pacote de diárias em hotéis, pousadas e resorts para
                    quem tem perfil de planejamento de viagens e busca por descontos, promoções e tarifas mais
                    baratas. Garanta diárias mais baratas que as cobradas diretamente no balcão do hotel ou em
                    outras plataformas de reservas de hospedagem.
                  </p>
                  <p>
                    Vale a pena entrar na Montreal Viagens para aproveitar várias outras vantagens:
                  </p>
                  <ul class="ul-disc">
                    <li>24 meses para utilizar, mediante renovação</li>
                    <li>Assinatura anual com pagamentos mensais</li>
                    <li>Sem taxas adicionais como complemento e regime de alimentação</li>
                    <li>Taxa de adesão grátis, mediante fidelização de 12 meses.</li>
                    <li>Pagamento em 12x sem juros e sem comprometer o limite do cartão de crédito</li>
                    <li>Planos para 2 ou 3 pessoas</li>
                    <li>Café da manhã grátis em todos os planos</li>
                    <li>Resorts all inclusive*</li>
<!--                    <li>Hotéis internacionais*</li>-->
                    <li>
                      Todo cliente participa automaticamente do
                      <a class="link-default" href="/vantagens">Montreal +,</a>
                      um clube de vantagens que dá
                      desconto em centena de lojas parceiras, ofertando produtos e serviços com ofertas
                    </li>
                    <li>
                      <a class="link-default" href="/indique-e-ganhe">Programa de Indicação de Amigos:</a>
                      você ganha bônus para utilizar em seu plano de
                      hospedagem. Quanto mais amigos indicar, mais irá ganhar!
                    </li>
                  </ul>
                  <p>
                    Quer saber mais detalhes sobre nossos benefícios?
                    <a class="link-default" href="/contatos">Fale agora com um de nossos consultores!</a>
                  </p>
                  <p>
                    <small>*Consulte os resorts all inclusive e os hotéis internacionais disponíveis em cada plano</small>
                  </p>
                </label>
              </div>
            </label>
          </div>

          <div id="ac-5" class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-5" class="btn-control" />
            <label class="btn" for="btnControl-5">
              <div class="perguntas">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  <strong>5) Como utilizar?</strong><br>
                  <small>
                    <span style="font-weight: 700">
                     Administre suas diárias em hotéis, pousadas e resorts pelo nosso Aplicativo.
                    </span>
                  </small>
                </p>
                <label class="area-check">

                  <p>
                    Após ter sua assinatura de hotéis adquirida, o processo de marcação de reservas e
                    administração de diárias pode ser realizado em nosso
                    <a class="link-default" target="_blank" href="https://assinatura.viagensmontreal.com/novo-app-montreal">
                      Aplicativo
                    </a> ou em
                    nossa <span style="font-weight: 700">Central de Atendimento ao Cliente</span>
                    com um de nossos consultores no 0800 610 3311.
                  </p>
                  <p>
                    Planejar sua viagem com antecedência é primordial para garantir a hospedagem no hotel,
                    pousada ou resort desejado. Para isso, é importante estar sempre atento ao Calendário de Reservas
                    da Montreal, que pode ser consultado no App ou com a Mel no WhatsApp.
                    <span style="font-weight: 700">
                      Lembrando que a data máxima para marcação é de 90 dias antes da data do check-in no hotel.
                    </span>
                    Depois de realizar sua reserva é só aguardar a confirmação para partir para o destino.
                  </p>

                  <p>
                    <span style="font-weight: 700">Importante saber: </span>
                    os planos da Montreal possuem café da manhã incluso e alguns hotéis
                    trabalham com regime de alimentação, sendo eles:
                  </p>
                  <p>
                    <span style="font-weight: 700">Meia pensão:</span> almoço ou jantar
                  </p>
                  <p>
                    <span style="font-weight: 700">Pensão completa:</span> almoço e jantar
                  </p>
                  <p>
                    <span style="font-weight: 700">All inclusive:</span> todas as refeições + lanches + petiscos + bebidas à vontade
                  </p>
                  <p>
                    Aqui você não precisa se preocupar em pagar nada mais além de suas mensalidades:
                    todo o regime de alimentação obrigatório do hotel está incluso!
                    Basta escolher uma acomodação incluída no seu plano e viajar.
                    E atenção: o plano não cobre refeições feitas no restaurante ou no bar dos hotéis que não tenham o
                    regime de alimentação na cobertura.
                  </p>
                  <p>
                    Ainda tem alguma dúvida? Confira as <span style="font-weight: 700">perguntas frequentes </span>
                    <a class="link-default" href="/perguntas-frequentes">aqui</a>.
                  </p>
                </label>
              </div>
            </label>
          </div>

          <div id="ac-6" class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-6" class="btn-control" />
            <label class="btn" for="btnControl-6">
              <div class="perguntas">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  <strong>6) São milhares de hotéis em todo Brasil</strong><br>
<!--                  <small>-->
<!--                    <span style="font-weight: 700">-->
<!--                      São milhares de hotéis em t#odo Brasil e tem até internacionais.-->
<!--                    </span>-->
<!--                  </small>-->
                </p>
                <label class="area-check">
                  <p>
                    A Montreal trabalha como um intermediador entre os estabelecimentos hoteleiros e os
                    hóspedes, negociando diárias mais baratas para você economizar em sua viagem.
                  </p>
                  <p>
                    Nosso portfólio de hospedagem conta com os melhores hotéis, pousadas e resorts do Brasil que são
                    selecionados em relação ao excelente serviço prestado, instalações de qualidade entre outras
                    qualificadoras. Conheça algumas de nossas redes parceiras:
                  </p>

                  <ul>
                    <li><a target="_blank" href="https://all.accor.com/brasil/index.pt-br.shtml">AccorHotels</a></li>
                    <li><a target="_blank" href="https://www.beachpark.com.br/">Beach Park</a></li>
                    <li><a target="_blank" href="https://www.bestwestern.com.br/">Best Western</a></li>
                    <li><a target="_blank" href="https://www.bluetree.com.br/">Blue Tree Hotels</a></li>
                    <li><a target="_blank" href="https://www.bourbon.com.br/">Bourbon Hotéis e Resorts</a></li>
                    <li><a target="_blank" href="https://www.hiltonhotels.com/pt_BR/">Hotels by Hilton</a></li>
                    <li><a target="_blank" href="https://www.intercityhoteis.com.br/">Intercity Hotels</a></li>
                    <li><a target="_blank" href="https://www.laghettohoteis.com.br/">Laghetto Hotéis</a></li>
                    <li><a target="_blank" href="https://www.marriott.com.br/loyalty.mi">Marriott Bonvoy</a></li>
                    <li><a target="_blank" href="https://reservas.tauaresorts.com.br/">Tauá Hotéis</a></li>
                    <li><a target="_blank" href="https://www.vilagale.com/">Vila Galé Hotéis</a></li>
                    <li><a target="_blank" href="https://windsorhoteis.com/">Windsor Hotéis</a></li>
                    <li><a target="_blank" href="https://www.wyndhamhotels.com/pt-br/wyndham">Wyndham</a></li>
                    <li>E várias outras</li>
                  </ul>
                  <p>
                    Nossos hotéis parceiros possuem instalações modernas, baseadas nos conceitos de
                    acessibilidade para todos. Também possuímos opções de hotéis pet friendly, hotéis com
                    espaços de recreação infantil, hotéis com cassinos, hotéis com parques aquáticos, hotéis com
                    decorações temáticas, hotéis com trilhas ecológicas, hotéis com bibliotecas, hotéis com salões
                    de jogos, hotéis com academias, hotéis com sauna, hotéis com praia privativa, hotéis com área
                    de pesca, hotéis com lavanderia, hotéis com spa, hotéis com piscinas, hotéis com jacuzzi,
                    dentre muitas outras opções.
                  </p>
                  <p>
                    Para mais informações sobre os hotéis contratados,
                    <a class="link-default" href="/hoteis">clique aqui!</a>
                  </p>

                </label>
              </div>
            </label>
          </div>

          <div id="ac-7" class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-7" class="btn-control" />
            <label class="btn" for="btnControl-7">
              <div class="perguntas">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  <strong>7) Montreal Agência de Viagem</strong><br>
                  <small>
                    <span style="font-weight: 700">Seu próximo destino mais completo com a gente.</span>
                  </small>
                </p>
                <label class="area-check">
                  <p>
                    O Grupo Montreal possui uma Agência de Viagem para completar sua hospedagem realizada pelo
                    nosso clube de assinatura.
                    Pela Agência, nossos consultores estão aptos para atendê-los pelo telefone
                    <a class="link-default" href="tel:0800613311">0800 610 3311</a>,
                    de segunda a sexta-feira, das 9h às 18h.
                  </p>
                  <p>
                    Confira os produtos que oferecemos para clientes Montreal e para o público em geral e garanta sua viagem completa:
                  </p>
                  <ul class="ul-disc">
                    <li>Pacotes nacionais</li>
                    <li>Pacotes internacionais</li>
                    <li>Hotéis no exterior</li>
                    <li>Passagens aéreas</li>
                    <li>Cruzeiros</li>
                    <li>Seguro-viagem</li>
                    <li>Aluguel de carros</li>
                    <li>Ingressos para parques</li>
                    <li>City Tour</li>
                  </ul>

                  <p>
                    <span style="font-weight: 700">Informação importante:</span>
                    seu plano de assinatura da Montreal contempla apenas a hospedagem,
                    logo os serviços acima são adquiridos com pagamento a parte.
                  </p>
                  <p>
                    <strong>Serviço:</strong>
                  </p>
                  <p>
                    <span style="font-weight: 700">Montreal Agência de Viagem</span>
                    <br>
                    <a href="tel:0800613311">0800 610 3311</a>
                  </p>
                </label>
              </div>
            </label>
          </div>

          <div id="ac-8" class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-8" class="btn-control" />
            <label class="btn" for="btnControl-8">
              <div class="perguntas">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  <strong>8) Programa de indicação</strong><br>
                  <small>
                    <span style="font-weight: 700">
                    Indique seus amigos e ganhe bônus* por cada indicação que seja convertida em novos clientes!
                    </span>

                  </small>
                </p>
                <label class="area-check">
                  <p>É isso mesmo: em nosso programa de <a class="link-default" href="/indique-e-ganhe">indicação de amigos</a>, nossos clientes
                    <span style="font-weight: 600">recebem bonificações</span> por cada indicação que seja convertida em novos clientes,
                    não possuindo limitações ou restrições acerca de quantas pessoas indicar.
                  </p>
                  <p>
                    Seus bônus serão utilizados como abatimento em seu plano de hospedagem no mês seguinte ao pagamento
                    de 4 parcelas dos planos de cada um dos seus amigos indicados.
                  </p>

                  <p>
                    Seus amigos merecem viajar com todas nossas vantagens e você com um ótimo desconto para economizar, não é?
                  </p>
                  <ul class="ul-disc">
                      <li>Pagamento em 12x sem juros sem comprometer o limite do seu cartão</li>
                      <li>24 meses para utilizar, mediante renovação</li>
                      <li>Sem taxas de complemento e alimentação, nos hotéis disponíveis em cada categoria</li>
                      <li>Café da manhã incluso em todos os planos</li>
                      <li>Taxa de adesão grátis, mediante fidelização</li>
                  </ul>
                  <p>
                    Para conhecer o regulamento completo do programa,
                    <a class="link-default"
                       href="https://www.montrealguru.guru/regulamentos-promos/?utm_source=Regulamento+Indique+Amigos+Montreal+Site&utm_id=Regulamento+Indique+Amigos+Montreal+Site&utm_term=Regulamento+Indique+Amigos+Montreal+Site">
                      clique aqui.
                    </a>
                  </p>
                  <p style="font-size: 0.8rem">
                    *O valor máximo de recebimento do bônus está limitado ao plano Ideal de 7 diárias,
                    duplo ou triplo, dependendo da modalidade escolhida por seu amigo indicado.
                  </p>
                  <p>
                    Quer conhecer mais sobre nosso Programa de Indicação ou indicar um amigo?
                    <a class="link-default" href="/indique-e-ganhe">Clique Aqui</a>
                    e saiba mais.
                  </p>

                </label>
              </div>
            </label>
          </div>

          <div id="ac-9" class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-9" class="btn-control" />
            <label class="btn" for="btnControl-9">
              <div class="perguntas">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  <strong>9) Programa de vantagens Montreal +</strong><br>
                  <small>
                    <span style="font-weight: 700">
                      Desconto em milhares de produtos e serviços com nossos parceiros!
                    </span>
                  </small>
                </p>
                <label class="area-check">
                  <p>
                    O <a href="/vantagens">Programa de Vantagens Montreal+</a> é mais um dos
                    <span style="font-weight: 700">benefícios</span>
                    disponíveis para nossos clientes.
                    Quem faz parte do Clube de Assinatura da Montreal,
                    <span style="font-weight: 700">garante descontos em vários produtos e serviços</span>
                    de empresas parceiras.
                  </p>
                  <p>
                    São <span style="font-weight: 700">produtos</span>
                    como roupas, alimentos, eletrodomésticos, móveis, utilidades para o lar, equipamentos esportivos,
                    itens para pets, mochilas, brinquedos, cosméticos, informática, automotivo e muito mais.
                  </p>

                  <p>
                    Já como destaque nos
                    <span style="font-weight: 700">serviços</span>
                    temos descontos em cursos (graduação, pós-graduação, mestrado, idiomas) academias, planos de celular,
                    consertos automotivos, tratamentos odontológicos e vários outros.
                  </p>

                  <p>
                    O cliente acessa os benefícios direto no
                    <a class="link-default" href="https://assinatura.viagensmontreal.com/novo-app-montreal">app da Montreal</a>,
                    sem sair de casa e com o conforto e segurança que merece.
                  </p>

                  <p>Confira alguns parceiros:</p>
                  <ul class="ul-disc">
                    <li>Magalu</li>
                    <li>Extra</li>
                    <li>Casas Bahia</li>
                    <li>Ponto Frio</li>
                    <li>Petz</li>
                    <li>Netshoes</li>
                    <li>Philips</li>
                    <li>Cia Toy</li>
                    <li>Riachuelo</li>
                    <li>Renner</li>
                    <li>E muitos outros</li>
                  </ul>

                  <p>Quer conhecer todas as nossas empresas parceiras? Acesse o
                    <a class="link-default" href="https://assinatura.viagensmontreal.com/novo-app-montreal">
                      app da Montreal
                    </a>.
                  </p>

                </label>
              </div>
            </label>
          </div>



          <h5>Perguntas Frequentes</h5>
          <p class="section-description">Ainda com dúvidas? Veja abaixo as perguntas frequentes sobre a Montreal.</p>
          <a routerLink="/perguntas-frequentes" class="btn-verde">IR PARA A FAQ</a>

          <br>
          <div class="montreal-social-contatos">

            <h5>Fale Conosco Online</h5>

            <p class="section-description">
              Entre em contato com a gente pelo WhatsApp
              <span style="font-weight: 700">Whatsapp</span>, no
              <span style="font-weight: 700">Chat</span>,
              ou em nossas
              <span style="font-weight: 700">redes sociais!</span>,
            </p>

            <p class="section-description">
              No Whats e no chat você conta com o atendimento da Mel, nossa assistente virtual, 24 horas
              <br>
              por dia durante toda a semana. Já nas redes sociais o atendimento é de segunda à sexta-feira, das 9h às 18h.
            </p>

            <a href="http://api.whatsapp.com/send?1=pt_BR&amp;phone=5561996863311" target="_blank"
              class="btn-verde btn-social"><i class="fab fa-whatsapp"></i> WHATSAPP</a>

          </div>

          <div class="montreal-social" *ngIf="!isMobile">
            <p>REDES SOCIAIS</p>
            <ul>
              <li>
                <a title="Instagram Montreal - Clube de Hospedagem" href="https://www.instagram.com/clubemontreal/" target="_blank">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
              <li>
                <a title="Facebook Montreal - Clube de Hospedagem" href="https://www.facebook.com/ClubeMontreal/" target="_blank">
                  <i class="fab fa-facebook-square"></i>
                </a>
              </li>
              <li>
                <a title="Youtube Montreal - Clube de Hospedagem" href="https://www.youtube.com/user/clubemontreal" target="_blank">
                  <i class="fab fa-youtube"></i>
                </a>
              </li>
              <li>
                <a title="LinkedIn Montreal - Clube de Hospedagem" href="https://pt.linkedin.com/company/montreal-clube-de-hospedagem" target="_blank">
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </li>
            </ul>
          </div>
          <div class="columns">
            <div class="column is-one-third regulamento">
              <h5 id="target_regulamento_clube_montreal">Regulamento da Montreal Viagens</h5>
              <div class="area-pdf">
                <a [href]="srcRegulamento | urlPipe" target="_blank">
                  <i class="fas fa-file-download"></i>
                  <i class="far fa-external-link-alt"></i>
                  <p><strong>Regulamento Planos Montreal</strong></p>
                  <p><span class="link-default">Clique aqui</span> e confira os detalhes <br>e as regras da Montreal.</p>
                </a>
              </div>
            </div>
<!--            <div class="column is-one-third regulamento">-->
<!--              <h5 id="target_regulamento_clube_montreal_antes_14_01_2023">Regulamento Anterior 14/01/2023</h5>-->

<!--              <div class="area-pdf">-->
<!--                <a href="https://www.viagensmontreal.com/design/Regulamento_Promo/MONTREAL_FACILITA_7_PLANOS-APROVADO.pdf" target="_blank">-->
<!--                  <i class="fas fa-file-download"></i>-->
<!--                  <i class="far fa-external-link-alt"></i>-->
<!--                  <p><strong>Regulamento Planos Montreal</strong></p>-->
<!--                  <p><span class="link-default">Clique aqui</span> e confira os detalhes <br>e as regras da Montreal.</p>-->
<!--                </a>-->
<!--              </div>-->
<!--            </div>-->
            <div class="column is-one-third regulamento">
              <h5 id="target_regulamento_clube_montreal_promocao">Outros Regulamentos</h5>

              <div class="area-pdf">
                <a href="https://www.montrealguru.guru/regulamentos-promos/" target="_blank">
                  <i class="far fa-file-alt"></i>
                  <i class="far fa-external-link-alt"></i>
                  <p><strong>Acesse os Regulamentos</strong></p>
                  <p><span class="link-default">Veja aqui</span> os regulamentos antigos e das últimas promoções.</p>
                </a>
              </div>
            </div>
          </div>

          <h5 id="target_canais_contato">Outros Canais de Contato</h5>

          <div class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-10" class="btn-control" />
            <label class="btn" for="btnControl-10">
              <div class="contatos">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  Atendimento ao cliente <strong>0800 610 3311</strong>
                </p>
                <label class="area-check">
                  <p>
                    Marcação, alteração, revisão e cancelamento de reservas, consulta de saldo de diárias,
                    atualização cadastral, dúvidas relacionadas a reservas, segunda via de voucher, prorrogação,
                    antecipação, mudança de categoria, informações sobre hotéis e período de marcação.
                    <br>
                    Operações com reservas também estão disponíveis pelo
                    <a class="link-default" href="https://assinatura.viagensmontreal.com/novo-app-montreal">Aplicativo da Montreal</a>.
                    <br>
                    <strong>Horário de Atendimento: 2ª a 6ª, das 9h às 18h.</strong><br>
                  </p>
                </label>
              </div>
            </label>
          </div>

          <div class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-11" class="btn-control" />
            <label class="btn" for="btnControl-11">
              <div class="contatos">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  Televendas <strong>0800 610 2200</strong>
                </p>
                <label class="area-check">
                  <p>
                    Nossos especialistas estão prontos para auxiliar na compra de planos de assinatura de hotéis.
                    Também poderão tirar dúvidas sobre o Clube e cadastrar indicações,
                    bem como entrar em contato com seus amigos indicados.
                    <br>
                    <br>
                    <strong>Horário de Atendimento: 2ª a 6ª, das 9h às 18h.</strong>
                  </p>
                </label>
              </div>
            </label>
          </div>

          <div class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-12" class="btn-control" />
            <label class="btn" for="btnControl-12">
              <div class="contatos">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  Ouvidoria <strong>0800 642 6633</strong>
                </p>
                <label class="area-check">
                  <p>
                    Se sua reclamação foi tratada em nossos canais de atendimento, mas a solução não foi satisfatória,
                    entre em contato com a ouvidoria da Montreal. Para isso,
                    é necessário ter sido atendido em um dos nossos canais de atendimento oficiais
                    e nos informar o número do protocolo.
                    <br>
                    <br>
                    <strong> Horário de Atendimento: 2ª a 6ª, das 9h às 18h, exceto feriados.</strong>
                  </p>
                </label>
              </div>
            </label>
          </div>

          <div class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-13" class="btn-control" />
            <label class="btn" for="btnControl-13">
              <div class="contatos">
                <p>
                  Cliente no exterior <strong>+55 61 3323-3311</strong>
                </p>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="chat como-funciona">
        <app-chat (closeChat)="closeChat($event)" [showDisplay]="showChat"></app-chat>
      </div>
    </div>
  </section>
  <app-footer></app-footer>
</div>
